import React from 'react'
import { Calendar } from 'react-date-range'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { ProductImage } from 'app/common/Common'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { getOrdersSummary } from 'client/utils/api-routes-analytics'
import { OrdersContext } from 'contexts/OrdersContext'
import moment from 'moment'
import {
  $DCprimaryColor,
  ButtonsGroup,
  DcBreadcrumbs,
  DcButton,
  DcDropDown,
  DcFlexBox,
  PixelCollapse,
  PixelCurrency,
  PixelFactoryContext,
  PixelIcon,
  PixelPageContainer,
  PixelPopover,
  PixelTable,
  PixelText,
  PixelTooltip,
  Section,
  SectionActions,
  SectionContent,
  SectionTitle,
  colors,
} from 'pixel-base'
import * as locales from 'react-date-range/dist/locale'
import { AjaxResponse } from 'rxjs-compat'
import { env } from 'shared/env'
import styled from 'styled-components'
import ChevronDownIcon from 'utils/icons/chevron-down-icon'
import ChevronLeftIcon from 'utils/icons/chevron-left-icon'
import ChevronRightIcon from 'utils/icons/chevron-right-icon'
import ChevronUpIcon from 'utils/icons/chevron-up-icon'
import PrintIcon from 'utils/icons/print-icon'

import AlertCard from './Alert'
import CollapseAbleCard from './CollapseAbleCard'
import OrdersCard from './OrderAlertCard'
import type { IStoreList, ITodayOrders } from '../../../../../decl'
import { IPixelFactory } from '../../../../../decl.d'
const tenant_info = JSON.parse(localStorage.getItem('tenant_info') || '{}')

const DailyReportDashBoard = () => {
  const { state } = React.useContext(OrdersContext)
  const [isClosePopover, setIsClosePopover] = React.useState<boolean>(false)
  const [filters, setFilters] = React.useState<{
    date: Date | string | moment.Moment
    store_id: string
  }>({
    date: moment(new Date()).format('YYYY-MM-DD'),
    store_id: 'all',
  })
  const [isExpanded, setExpanded] = React.useState(true)
  const [isExpanded30Days, setExpanded30Days] = React.useState(true)

  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const ReportsRef = React.useRef(null)

  const [storesList, setStoresList] = React.useState<IStoreList>([])
  const [report, setReport] = React.useState<ITodayOrders>({
    orders: {
      label: 'Orders Progress',
      description: 'Orders Progress',
      todays_order_progress_detail: [],
    },
    orders_tracking: {
      label: 'Orders Tracking',
      description: 'Orders Tracking',
      todays_tracking_progress_details: [],
    },
    todays_top_5_products: {
      label: 'Top 5 Products',
      description: 'Top 5 Products',
      today_top_5_products_details: [],
    },
    todays_logistics_distribution: {
      label: 'Logistics Distribution',
      description: 'Logistics Distribution',
      todays_logistics_distribution_details: [],
    },
    todays_warehouse_distribution: {
      label: 'Warehouse Distribution',
      description: 'Warehouse Distribution',
      todays_warehouse_distribution_details: [],
    },
    todays_courier_receivables: {
      label: 'Courier Receivables',
      description: 'Courier Receivables',
      todays_courier_receivables_details: [],
    },
    last_30_days_missing_parcels: {
      label: 'Missing Parcels',
      description: 'Missing Parcels',
      last_30_days_missing_parcels_details: [],
    },
    last_30_days_order_progress: {
      label: 'Order Progress',
      description: 'Order Progress',
      last_30_days_order_progress_details: [],
    },
    last_30_days_top_5_products: {
      label: 'Top 5 Products',
      description: 'Top 5 Products',
      last_30_days_top_5_products_details: [],
    },
  })
  const formateData = (data, storeID) => {
    let allOrders = []
    if (storeID === 'all') {
      allOrders = data?.orders?.todays_order_progress_detail
    } else {
      allOrders = data?.orders?.todays_order_progress_detail?.filter(
        (item: IStoreList) => item.store_id == storeID,
      )
    }
    const temp = {
      cancelled_orders: 0,
      cancelled_revenue: 0,
      on_hold_orders: 0,
      shipped_orders: 0,
      shipped_revenue: 0,
      total_orders: 0,
      total_revenue: 0,
    }
    allOrders?.map((item: IReportOrders) => {
      temp.cancelled_orders += item.cancelled_orders
      temp.cancelled_revenue += item.cancelled_revenue
      temp.on_hold_orders += item.on_hold_orders
      temp.shipped_orders += item.shipped_orders
      temp.shipped_revenue += item.shipped_revenue
      temp.total_orders += item.total_orders
      temp.total_revenue += item.total_revenue
    })
    return temp
  }
  const breadcrumbs = [
    {
      name: 'Analytics',
      active: false,
    },
    {
      name: 'Daily Report',
      active: true,
    },
  ]
  const newDate = `${moment(filters.date).format('DD MMM YYYY')}`

  const columns = [
    {
      name: 'Image',
      sortable: true,
      width: '10%',
      selector: (row) => <ProductImage path={row.image_path} />,
    },
    {
      name: 'Product Name',
      sortable: true,
      width: '40%',
      selector: (row) => <PixelText multiLine>{row.product_name}</PixelText>,
    },
    {
      name: `Revenue  (${tenant_info.default_currency_symbol})`,
      sortable: true,
      width: '20%',
      selector: (row) => (
        <PixelCurrency hideSymbol={true} value={row.total_revenue} />
      ),
    },
    {
      name: (
        <PixelText>
          Avg Unit Price (${tenant_info.default_currency_symbol})
        </PixelText>
      ),
      sortable: true,
      width: '15%',
      selector: (row) => (
        <PixelCurrency hideSymbol={true} value={row.avg_unit_price} />
      ),
    },
    {
      name: <PixelText>Total Orders (Count)</PixelText>,
      width: '15%',
      selector: (row) => row.total_orders,
      sortable: true,
    },
  ]

  const getReport = () => {
    showLoader(ReportsRef)
    getOrdersSummary(filters).subscribe((res: AjaxResponse<ITodayOrders>) => {
      if (res.response.data) {
        hideLoader(ReportsRef)
        const data = res.response.data
        setReport({
          ...report,
          orders: data?.todays_order_progress,
          orders_tracking: data?.todays_tracking_progress,
          todays_top_5_products: data?.todays_top_5_products,
          todays_logistics_distribution: data?.todays_logistics_distribution,
          todays_warehouse_distribution: data?.todays_warehouse_distribution,
          todays_courier_receivables: data?.todays_courier_receivables,
          last_30_days_missing_parcels: data?.last_30_days_missing_parcels,
          last_30_days_order_progress: data?.last_30_days_order_progress,
          last_30_days_top_5_products: data?.last_30_days_top_5_products,
        })
      } else {
        hideLoader(ReportsRef)
      }
    })
  }
  React.useEffect(() => {
    getReport()
  }, [filters.date])
  React.useEffect(() => {
    setStoresList(state?.linkedStores)
  }, [state])
  const baseURL = env.SERVER_ADDR
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: `1px solid ${colors.grayBorderLight}`,
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              justifyContent="flex-end"
              padding="5px 20px"
            >
              <DcButton
                onClick={() => {
                  window.open(
                    `${baseURL}api/v2/print/daily/report/${token}/${filters.date}`,
                  )
                }}
                variant="outline-primary"
                size="sm"
              >
                <PrintIcon color="inherit" size={18} /> Print Report
              </DcButton>
              &nbsp; &nbsp;
              <ButtonsGroup
                style={{
                  gap: '15px',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
              >
                <PixelTooltip tooltipText="Previous">
                  <DcButton
                    // disabled={navigationProcess.prevId === null}
                    onClick={() => {
                      const prevDate = moment(filters.date)
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                      setFilters({
                        ...filters,
                        date: prevDate,
                      })
                    }}
                    size="sm"
                    variant="outline-primary"
                  >
                    <ChevronLeftIcon size={10} color="inherit" />
                  </DcButton>
                </PixelTooltip>

                <PixelPopover
                  PopoverContent={
                    <Calendar
                      color={$DCprimaryColor}
                      onChange={(item) => {
                        setFilters({
                          ...filters,
                          date: moment(item).format('YYYY-MM-DD'),
                        })
                        setIsClosePopover(true)
                      }}
                      locale={locales[{ enUS: 'English (United States)' }]}
                      date={moment(filters.date).toDate()}
                    />
                  }
                  popoverPlacement={'left'}
                  closePopover={isClosePopover}
                  overlayButton={<OrderPage>{newDate}</OrderPage>}
                  styledPopover={{
                    width: '355px',
                    maxWidth: '355px',
                    padding: '10px',
                    position: 'relative !important',
                  }}
                  onPopoverExit={() => {
                    setIsClosePopover(false)
                    return {}
                  }}
                />
                <PixelTooltip tooltipText="Next">
                  <DcButton
                    disabled={moment(filters.date).isSame(new Date(), 'day')}
                    onClick={() => {
                      const nextDate = moment(filters.date).add(1, 'days')
                      setFilters({
                        ...filters,
                        date: nextDate,
                      })
                    }}
                    size="sm"
                    variant="outline-primary"
                  >
                    <ChevronRightIcon size={10} />
                  </DcButton>
                </PixelTooltip>
              </ButtonsGroup>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            overflow: 'auto',
            height: 'calc(100vh - 100px)',
            padding: '20px',
          }}
          className="Reports"
          ref={ReportsRef}
        >
          <SectionContent>
            <PixelCollapse
              defaultExpanded={true}
              onCollapseChange={(isExpanded) => {
                setExpanded(isExpanded)
              }}
              collapseController={
                <MainHeader>
                  <SectionHeaderLeft id="collapse-controller">
                    <SectionTitle
                      style={{
                        margin: '0px',
                      }}
                    >
                      Today
                    </SectionTitle>
                  </SectionHeaderLeft>
                  <SectionHeaderRight id="collapse-controller">
                    {isExpanded ? (
                      <ChevronUpIcon color={$DCprimaryColor} size={10} />
                    ) : (
                      <ChevronDownIcon color={$DCprimaryColor} size={10} />
                    )}{' '}
                  </SectionHeaderRight>
                </MainHeader>
              }
            >
              <div>
                <Header className="withFilter">
                  <Header>
                    <MainHeader>
                      {report?.orders.label || 'Orders Progress'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={report.orders.description}
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>

                  <div
                    style={{
                      width: '30%',
                    }}
                  >
                    <DcDropDown
                      required
                      placeholder="Select Store"
                      options={[
                        {
                          store_name: 'All Stores',
                          store_id: 'all',
                        },
                        ...storesList,
                      ].map((p: IStoreList) => {
                        return {
                          label: p.store_name,
                          value: p.store_id,
                        }
                      })}
                      value={filters.store_id}
                      onChange={(e) => {
                        setFilters({
                          ...filters,
                          store_id: e.target.value,
                        })
                      }}
                    />
                  </div>
                </Header>
                <StatsInnerContainer>
                  <OrdersCard
                    variant={'success'}
                    title={'Received'}
                    totalCount={
                      formateData(report, filters.store_id).total_orders
                    }
                    mainDec={'Orders'}
                    isCOD={true}
                    COD={formateData(report, filters.store_id).total_revenue}
                    CODDec={'Revenue'}
                  />
                  <OrdersCard
                    variant={'success'}
                    title={'Shipped'}
                    totalCount={
                      formateData(report, filters.store_id).shipped_orders
                    }
                    mainDec={'Orders'}
                    isCOD={true}
                    COD={formateData(report, filters.store_id).shipped_revenue}
                    CODDec={'Revenue'}
                  />

                  <OrdersCard
                    variant={'success'}
                    title={'Canceled'}
                    totalCount={
                      formateData(report, filters.store_id).cancelled_orders
                    }
                    mainDec={'Orders'}
                    isCOD={true}
                    COD={
                      formateData(report, filters.store_id).cancelled_revenue
                    }
                    CODDec={'Revenue'}
                  />

                  <OrdersCard
                    variant={'success'}
                    title={'OnHold'}
                    totalCount={
                      formateData(report, filters.store_id).on_hold_orders
                    }
                    mainDec={'Orders'}
                    isCOD={true}
                    COD={''}
                    CODDec={'Revenue'}
                  />
                </StatsInnerContainer>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {report?.orders_tracking.label || 'Tracking Progress'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={report.orders_tracking.description}
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer>
                  <OrdersCard
                    mainDec={'Orders'}
                    variant={'info'}
                    title={'Delivered'}
                    totalCount={
                      report.orders_tracking
                        ?.todays_tracking_progress_details[0]?.delivered
                    }
                  />

                  <OrdersCard
                    mainDec={'Orders'}
                    variant={'info'}
                    title={'In Transit'}
                    isCod={false}
                    totalCount={
                      report.orders_tracking
                        ?.todays_tracking_progress_details[0]?.['in-transit']
                    }
                  />

                  <OrdersCard
                    mainDec={'Orders'}
                    variant={'info'}
                    title={'Refunded'}
                    totalCount={
                      report.orders_tracking
                        ?.todays_tracking_progress_details[0]?.refunded
                    }
                  />

                  <OrdersCard
                    mainDec={'Orders'}
                    variant={'info'}
                    title={'Return Received'}
                    totalCount={
                      report.orders_tracking
                        ?.todays_tracking_progress_details[0]?.return_received
                    }
                  />
                </StatsInnerContainer>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {' '}
                      {report?.todays_logistics_distribution?.label ||
                        'Logistics Distribution'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={
                        report.todays_logistics_distribution?.description
                      }
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer>
                  {report.todays_logistics_distribution?.todays_logistics_distribution_details?.map(
                    (item, index) => {
                      return (
                        <CollapseAbleCard
                          key={index}
                          variant={'primary'}
                          title={item.courier_name}
                          totalCount={item.total_item_count}
                          mainDec={'Items'}
                          isCourier={true}
                          logo={item.courier_logo}
                          isCOD={true}
                          COD={item.total_cod_amount}
                          CODDec={'COD Amount'}
                          extraLines={[
                            {
                              title: item.package_verified_count,
                              dec: 'Package Verified',
                            },

                            {
                              title: item.total_dispatches,
                              dec: 'Dispatches',
                            },
                            {
                              title: item.total_packages_count,
                              dec: 'Packages',
                            },
                            {
                              title: item.total_prepaid_packages_count,
                              dec: 'Prepaid Packages',
                            },
                            {
                              title: item.total_shipped_amount,
                              dec: 'Shipped Amount',
                            },
                            {
                              title: item.unique_sku_count,
                              dec: 'Unique SKU Count',
                            },
                          ]}
                        />
                      )
                    },
                  )}
                </StatsInnerContainer>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {report?.todays_warehouse_distribution?.label ||
                        'Warehouse Distribution'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={
                        report.todays_warehouse_distribution?.description
                      }
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer>
                  {report.todays_warehouse_distribution?.todays_warehouse_distribution_details?.map(
                    (item, index) => {
                      return (
                        <AlertCard
                          key={index}
                          countINCurrency={true}
                          variant={'primary'}
                          title={item.warehouse_name}
                          totalCount={item.total_cod_amount}
                          mainDec={'Total COD Amount'}
                          isCourier={true}
                          extraLines={[
                            {
                              title: item.package_verified_count,
                              dec: 'Package Verified',
                            },
                            {
                              title: item.total_dispatches,
                              dec: 'Total Dispatches',
                            },
                            {
                              title: item.total_item_count,
                              dec: 'Total Items',
                            },
                            {
                              title: item.total_packages_count,
                              dec: 'Total Packages',
                            },
                            {
                              title: item.total_prepaid_packages_count,
                              dec: 'Total Prepaid Packages',
                            },
                            {
                              title: item.total_shipped_amount,
                              dec: 'Shipped Amount',
                            },
                            {
                              title: item.unique_sku_count,
                              dec: 'Unique SKU Count',
                            },
                          ]}
                        />
                      )
                    },
                  )}
                </StatsInnerContainer>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {' '}
                      {report?.todays_courier_receivables?.label ||
                        'Courier Receivables'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={
                        report.todays_courier_receivables?.description
                      }
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer>
                  {report.todays_courier_receivables?.todays_courier_receivables_details?.map(
                    (item, index) => {
                      return (
                        <AlertCard
                          key={index}
                          countINCurrency={true}
                          variant={'warning'}
                          title={item.courier_name}
                          totalCount={item.payment_due}
                          mainDec={'Payment Due'}
                          logo={item.courier_logo}
                          isCourier={true}
                          extraLines={[
                            {
                              title: item.payment_received,
                              dec: 'Payment Received',
                            },
                            {
                              title: item.shipping_charged,
                              dec: 'Shipping Charged',
                            },
                          ]}
                        />
                      )
                    },
                  )}
                </StatsInnerContainer>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {' '}
                      {report?.todays_top_5_products?.label ||
                        'Top 5 Products Sold Today'}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={report.todays_top_5_products?.description}
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer className="border">
                  <PixelTable
                    columns={columns}
                    data={
                      report?.todays_top_5_products
                        ?.today_top_5_products_details || []
                    }
                    pagination={false}
                  />
                </StatsInnerContainer>
              </div>
            </PixelCollapse>
          </SectionContent>
          &nbsp;
          <SectionContent>
            <PixelCollapse
              defaultExpanded={true}
              onCollapseChange={(expand) => {
                setExpanded30Days(expand)
              }}
              collapseController={
                <MainHeader>
                  <SectionHeaderLeft id="collapse-controller">
                    <SectionTitle
                      style={{
                        margin: '0px',
                      }}
                    >
                      Last 30 Days
                    </SectionTitle>
                  </SectionHeaderLeft>
                  <SectionHeaderRight id="collapse-controller">
                    {isExpanded30Days ? (
                      <ChevronUpIcon color={$DCprimaryColor} size={10} />
                    ) : (
                      <ChevronDownIcon color={$DCprimaryColor} size={10} />
                    )}
                  </SectionHeaderRight>
                </MainHeader>
              }
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: '20px',
                  }}
                >
                  <div
                    style={{
                      width: '50%',
                    }}
                  >
                    <SectionActions>
                      <Header>
                        <MainHeader>
                          {' '}
                          {report?.last_30_days_missing_parcels?.label}
                        </MainHeader>
                        <PixelPopover
                          PopoverContent={
                            report.last_30_days_missing_parcels?.description
                          }
                          popoverPlacement={'right'}
                          closePopover={isClosePopover}
                          overlayButton={
                            <DescriptionIcon>
                              <PixelIcon color="inherit" icon={faInfoCircle} />
                            </DescriptionIcon>
                          }
                          styledPopover={{
                            width: '355px',
                            maxWidth: '355px',
                            padding: '10px',
                            position: 'relative !important',
                          }}
                          onPopoverExit={() => {
                            setIsClosePopover(false)
                            return {}
                          }}
                        />
                      </Header>
                    </SectionActions>
                    <StatsInnerContainer>
                      {report.last_30_days_missing_parcels?.last_30_days_missing_parcels_details?.map(
                        (item, index) => {
                          return (
                            <AlertCard
                              style={{
                                width: '100%',
                              }}
                              key={index}
                              countINCurrency={true}
                              variant={'success'}
                              title={'Parcels'}
                              showTitle={false}
                              totalCount={item.missing_parcel_total_amount}
                              mainDec={'Missing Parcel Amount'}
                              isCourier={true}
                              extraLines={[
                                {
                                  title: item.parcels_missing,
                                  dec: 'Parcels Missing',
                                },
                                {
                                  title: item.parcels_received,
                                  dec: 'Parcels Received',
                                },
                                {
                                  title: item.total_returns,
                                  dec: 'Total Returns',
                                },
                              ]}
                            />
                          )
                        },
                      )}
                    </StatsInnerContainer>
                  </div>
                  <div
                    style={{
                      width: '50%',
                    }}
                  >
                    <SectionActions>
                      <Header>
                        <MainHeader>
                          {' '}
                          {report?.last_30_days_order_progress?.label}
                        </MainHeader>
                        <PixelPopover
                          PopoverContent={
                            report.last_30_days_order_progress?.description
                          }
                          popoverPlacement={'left'}
                          closePopover={isClosePopover}
                          overlayButton={
                            <DescriptionIcon>
                              <PixelIcon color="inherit" icon={faInfoCircle} />
                            </DescriptionIcon>
                          }
                          styledPopover={{
                            width: '355px',
                            maxWidth: '355px',
                            padding: '10px',
                            position: 'relative !important',
                          }}
                          onPopoverExit={() => {
                            setIsClosePopover(false)
                            return {}
                          }}
                        />
                      </Header>
                    </SectionActions>
                    <StatsInnerContainer>
                      {report.last_30_days_order_progress?.last_30_days_order_progress_details?.map(
                        (item, index) => {
                          return (
                            <AlertCard
                              style={{
                                width: '100%',
                              }}
                              key={index}
                              showTitle={false}
                              variant={'success'}
                              title={'Order Progress'}
                              totalCount={item.total_orders}
                              mainDec={'Total Orders'}
                              isCourier={true}
                              extraLines={[
                                {
                                  title: item.cancelled_orders,
                                  dec: 'Cancelled Orders',
                                },
                                {
                                  title: item.in_transit,
                                  dec: 'In Transit',
                                },
                                {
                                  title: item.order_not_processed,
                                  dec: 'Order Not Processed',
                                },
                                {
                                  title: item.refunded_orders,
                                  dec: 'Refunded Orders',
                                },
                                {
                                  title: item.unsuccessful_delivery,
                                  dec: 'Unsuccessful Delivery',
                                },
                              ]}
                            />
                          )
                        },
                      )}
                    </StatsInnerContainer>
                  </div>
                </div>
                <SectionActions>
                  <Header>
                    <MainHeader>
                      {' '}
                      {report?.last_30_days_top_5_products?.label}{' '}
                    </MainHeader>
                    <PixelPopover
                      PopoverContent={
                        report.last_30_days_top_5_products?.description
                      }
                      popoverPlacement={'right'}
                      closePopover={isClosePopover}
                      overlayButton={
                        <DescriptionIcon>
                          <PixelIcon color="inherit" icon={faInfoCircle} />
                        </DescriptionIcon>
                      }
                      styledPopover={{
                        width: '355px',
                        maxWidth: '355px',
                        padding: '10px',
                        position: 'relative !important',
                      }}
                      onPopoverExit={() => {
                        setIsClosePopover(false)
                        return {}
                      }}
                    />
                  </Header>
                </SectionActions>
                <StatsInnerContainer className="border">
                  <PixelTable
                    columns={columns}
                    data={
                      report.last_30_days_top_5_products
                        ?.last_30_days_top_5_products_details || []
                    }
                    pagination={false}
                  />
                </StatsInnerContainer>
              </div>
            </PixelCollapse>
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const DescriptionIcon = styled.div`
  width: 20px;
  height: 20px;

  > svg {
    border-radius: 10px;
    border: 2px solid ${colors.white};
  }
  &:hover {
    > svg {
      border: 2px solid ${colors.grayBorderLight};
      border-radius: 10px;
    }
  }
`
const StatsInnerContainer = styled.div`
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;
  margin-bottom: 20px;
  &.border {
    border: 1px solid ${colors.grayBorderLight};
  }
`
const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  width: 100%;
  gap: 10px;
  margin-bottom: 10px;
  &.withFilter {
    justify-content: space-between;
  }
`
const OrderPage = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${$DCprimaryColor};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
const MainHeader = styled.div<{ margin?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`
const SectionHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
`
const SectionHeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 20px;
  width: 10%;
`
export default DailyReportDashBoard
